module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//16.jpg?268ff8d9768ef8cae1e8ff9e98a36750";